import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { auth as Auth } from '@/store/authStore'
const app = createApp(App);

//Plugins
// perfect scrollbar
//import PerfectScrollbarPlugin from 'vue3-perfect-scrollbar';
//import 'vue3-perfect-scrollbar/style.css';
// bootstrap
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
// modals
import '@/assets/sass/components/custom-modal.scss';
//vue-meta
import { createHead } from '@vueuse/head';
const head = createHead();
//Sweetalert
import Swal from 'sweetalert2';
window.Swal = Swal;
// nouislider - later remove and add to page due to not working in page
import VueNouislider from 'vue3-nouislider';
import 'vue3-nouislider/dist/vue3-nouislider.css';
// vue input mask
import Maska from 'maska';
// smooth scroll
import { registerScrollSpy } from 'vue3-scroll-spy/dist/index';
registerScrollSpy(app, { offset: 118 });
//vue-i18n
import i18n from './i18n';
 

// 2. Access the current route via the router instance
// Note: If you need it immediately on load, use router.currentRoute
const route = router.currentRoute.value;

//https://stackoverflow.com/questions/63100658/add-global-variable-in-vue-js-3
//https://serversideup.net/url-query-parameters-with-javascript-vue-2-and-vue-3/
export var HsGlobals = {}

HsGlobals.howToLoad = 'database'

////DO NOT REARRANGE THESE - these have to match the javascript list in PickListControllers.cs
HsGlobals.groupConstants = {
    "unknown":0, 
    "stresslevel":1,            
    "installercontrib":2, 
    "one":3,
    "compgroup":4,
    "department":5,          
    "jobtitle":6, 
    "classcode":7,
    "managertype":8,
    "supervisortype":9,
    "coursetype":10,
    "trainedas":11,
    "region":12,
    "marketsector":13,
    "tabtype":14,
    "glcode":15,
    "jobtype":16
}
//STOP  AND READ ME: If you are adding a new pick list
// - don't forget to add (or better - REMVOE IF IT IF THERE IS A FALSE) ""canAdd"": true, to the id parameter in c#
//  - there are 2 more "lists" right below this item
//  - there is an enum at top of tblPickLists.cs and PickListController.cs

HsGlobals.groupConstantsString = {
    "0":"Unknown", 
    "1":"Stress Level",            
    "2":"Installer Contrib.", 
    "3":"One",
    "4":"Comp. Group",
    "5":"Department",          
    "6":"Job Title", 
    "7":"Class Code",
    "8":"Manager Type",
    "9":"Supervisor Type",
    "10":"Course Type",
    "11":"Trained As",
    "12":"Location",
    "13":"Division",
    "14":"Tab Type",
    "15":"GL Code",
    "16":"Job Type"
}

HsGlobals.groupVisibility = {
    "0":false, 
    "1":true,            
    "2":true,
    "3":false,
    "4":true,
    "5":true,         
    "6":true,
    "7":true,
    "8":false,
    "9":false,
    "10":true,
    "11":true,
    "12":true,
    "13":true,
    "14":true,
    "15":true
}
function isNumeric(num){
    return !isNaN(num)
  }
function setQueryStringDefaults(){
    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    
    let group = urlParams.get('group');
    if (!isNumeric(group)){
        group = HsGlobals.groupConstants[group].toString()
    }
    
    console.log("HAPPEN main.js FYI but route.params not defined")
    //store.commit('fe_setProject', route.params.project)

    console.log("9999999999", urlParams)
}
setQueryStringDefaults()

let locationFilter = '';
let userFilter = '';
let typeFilter = '';

app.provide('HsGlobals', HsGlobals)



// datatables
import { ClientTable } from 'v-tables-3';

// json to excel
import vue3JsonExcel from 'vue3-json-excel';

//vue-wizard
import VueFormWizard from 'vue3-form-wizard';
import 'vue3-form-wizard/dist/style.css';

// set default settings
import appSetting from './app-setting';
window.$appSetting = appSetting;
window.$appSetting.init();
app.config.performance = true;

/* OAuth2 */


app.use(store)
    .use(router)
    .use(i18n)
    .use(VueNouislider)
    .use(Maska)
    .use(ClientTable)
    .use(vue3JsonExcel)
    .use(VueFormWizard)
    .use(head)
    //.use(PerfectScrollbarPlugin)


import { VueNavigationClient } from './router/helpers';
const navigationClient = new VueNavigationClient(router);

// myMSALObj.setNavigationClient(customNav)
Auth.initialize(navigationClient)
    .then(() => {
        console.log("🔒 [Boot] MSAL Handshake successfully resolved. Mounting Application UI.");
        app.mount('#app');
    })
    .catch(err => {
        console.error("❌ [Boot] MSAL Initialization crashed during discovery lookup. Mounting fallback...", err);
        app.mount('#app');
    });
// end OAuth2

//app.mount('#app')
window.Auth = Auth
